module.exports = "/images/icon_reviewstar_inactive.png?1bb410f82e204062a8a0ca9730042ed2";